import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@myRedux/store";

export interface UserSettings {
  theme: 'dark' | 'light',
}

const initialState = {
  theme: 'light',
} as UserSettings;

export const userSettingsSlice = createSlice({
  name: 'userFromSessionSlice',
  initialState: initialState,
  reducers: {
    setTheme(state, action) {
      state.theme = action.payload
    }
  },
  extraReducers: (builder) => {},
});

export const selectTheme = (state: RootState) => state.user.userSettings.theme;

const { actions, reducer } = userSettingsSlice;
export const { setTheme } = actions;
export default reducer;